export enum SearchResultType {
  Files = 'Files',
  Templates = 'Templates',
  People = 'People',
  Contributors = 'Contributors',
  Groups = 'Groups',
}
